// menu
import { MdMenu as Menu } from 'react-icons/md';

// bulb
import { MdLightbulbOutline as Bulb } from 'react-icons/md';

// search
import { MdSearch as Search, MdSearchOff as SearchOff } from 'react-icons/md';

// copy
import { MdContentCopy as Copy } from 'react-icons/md';

// checkbox

import { IoIosCheckbox as Checkbox } from 'react-icons/io';
import {
  MdCheckBoxOutlineBlank as EmptyCheckbox,
  MdOutlineCheckBox as CheckboxOutline,
  MdOutlineIndeterminateCheckBox as CancelCheckboxOutline,
} from 'react-icons/md';

// edit
import { HiPencil as Edit } from 'react-icons/hi';
import { BiPencil as EditOutline } from 'react-icons/bi';

// label
import { MdLabel as Label, MdLabelOutline as LabelOutline } from 'react-icons/md';

// archive
import { MdOutlineArchive as Archive, MdOutlineUnarchive as Unarchive } from 'react-icons/md';

// delete
import { MdDelete as Delete } from 'react-icons/md';
import { RiDeleteBin6Line as DeleteOutline } from 'react-icons/ri';

// pin
import { RiPushpin2Fill as Pin, RiPushpin2Line as PinOutline } from 'react-icons/ri';

// add
import { MdAdd as Add } from 'react-icons/md';

// check
import { MdCheck as Check } from 'react-icons/md';

// clear
import { MdClear as Clear } from 'react-icons/md';

// select
import { MdCheckCircle as SelectCircle } from 'react-icons/md';

// more
import { MdMoreVert as More, MdMoreVert as MoreVert } from 'react-icons/md';

// palette
import { BiPalette as Palette } from 'react-icons/bi';

// image
import { BiImage as Image } from 'react-icons/bi';

// view by
import { RiLayoutGridLine as Grid } from 'react-icons/ri';
import { TiThMenuOutline as List } from 'react-icons/ti';

// dark mode
import { BiMoon as Moon, BiSun as Sun } from 'react-icons/bi';

// Logout
import { RiLogoutCircleRLine as Logout } from 'react-icons/ri';

// undo/redo
import { GrUndo as Undo, GrRedo as Redo } from 'react-icons/gr';

// share
import { RiShareBoxLine as Share } from 'react-icons/ri';

// Google
import { FcGoogle as Google } from 'react-icons/fc';

// Loading
import { RiLoader5Fill as Loading } from 'react-icons/ri';

// Save
import { FaRegSave as Save } from 'react-icons/fa';

// Drag
import { MdDragIndicator as Drag } from 'react-icons/md';

// Filter List
import { MdList as FilterList } from 'react-icons/md';

// link
import { MdLink as Link } from 'react-icons/md';

export {
  Menu,
  Bulb,
  Search,
  SearchOff,
  Copy,
  EmptyCheckbox,
  Checkbox,
  CheckboxOutline,
  CancelCheckboxOutline,
  Edit,
  EditOutline,
  Label,
  LabelOutline,
  Archive,
  Unarchive,
  Delete,
  DeleteOutline,
  Pin,
  PinOutline,
  Add,
  Check,
  Clear,
  SelectCircle,
  More,
  MoreVert,
  Palette,
  Image,
  Grid,
  List,
  Moon,
  Sun,
  Logout,
  Undo,
  Redo,
  Share,
  Google,
  Loading,
  Save,
  Drag,
  FilterList,
  Link,
};
